<template>
    <div class="td_content">
        <div class="td_side" @click.stop="menuVisibleClose()" :class="{ active: menuVisible }">
            <el-menu
                class="td_menu"
                :default-active="activeSlug"
                :default-openeds="defaultOpeneds"
                @open="handleOpen"
                @close="handleClose"
                background-color="#FFFFFF"
                text-color="#000000"
                active-text-color="#0042C1">
                <el-submenu 
                    :index="index+''" 
                    v-for="(item, index) in tutorialList" 
                    :key="index">
                    <template #title>
                        {{item.TitleMenu}}
                    </template>
                    <el-menu-item
                        :index="items.TitleMenuItem.Slug" 
                        v-for="(items, indexs) in item.TitleMenuItem" 
                        :key="indexs"
                        @click="handleClick(items.TitleMenuItem)">{{items.TitleMenuItem.Title}}
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>


        <div class="article" v-if="tutorialHtml != ''">
            <div class="td_page">
                <div class="page_pre" 
                :style="tutorialPre.Title != '' ? '':'visibility: hidden;'"
                @click="getTutorialPre(tutorialPre)">
                    <div class="page_name1">上一篇</div>
                    <div class="page_arrow_name">
                        <div class="page_arrow" style="margin: 0 3px 0 0;">&lt;</div>
                        <div class="page_name2">{{tutorialPre.Title}}</div>
                    </div>
                </div>
                <div class="page_next" 
                :style="tutorialNext.Title != '' ? '':'visibility: hidden;'"
                @click="getTutorialPre(tutorialNext)">
                    <div class="page_name1">下一篇</div>
                    <div class="page_arrow_name">
                        <div class="page_name2">{{tutorialNext.Title}}</div>
                        <div class="page_arrow" style="margin: 0 0 0 3px;">&gt;</div>  
                    </div>
                </div>
            </div>

            <div class="article-body">
                <div v-html="tutorialHtml" class="article-intro"></div>
            </div>

            <div class="td_page">
                <div class="page_pre" 
                :style="tutorialPre.Title != '' ? '':'visibility: hidden;'"
                @click="getTutorialPre(tutorialPre)">
                    <div class="page_name1">上一篇</div>
                    <div class="page_arrow_name">
                        <div class="page_arrow" style="margin: 0 3px 0 0;">&lt;</div>
                        <div class="page_name2">{{tutorialPre.Title}}</div>
                    </div>
                </div>
                <div class="page_next" 
                :style="tutorialNext.Title != '' ? '':'visibility: hidden;'"
                @click="getTutorialPre(tutorialNext)">
                    <div class="page_name1">下一篇</div>
                    <div class="page_arrow_name">
                        <div class="page_name2">{{tutorialNext.Title}}</div>
                        <div class="page_arrow" style="margin: 0 0 0 3px;">&gt;</div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/config/font-awesome.css'
import '@/config/style.css'
import { getTutorialDetail } from "@/config/api.js";
import { Menu, Submenu, MenuItem,MenuItemGroup} from 'element-ui'
import Vue from 'vue'
Vue.use(Menu).use(Submenu).use(MenuItem).use(MenuItemGroup)
export default {
    data() {
        return {
            category: "", // 分类
            article: "", // 文章

            tutorialList: [], // 菜单数据
            defaultOpeneds: [], // openeds展开集合
            tutorialHtml: "",
            tutorialPre: {},
            tutorialNext: {},
            activeSlug: "",
        }
    },
    beforeMount() {
        var that = this;
        var queryData = this.$route.query;
        if (queryData.hasOwnProperty("category")) {
            that.category = queryData.category;
            that.requestGetTutorial();
        }
    },
    methods: {
        // 获取教程详情
        requestGetTutorial() {
            var that = this;
            var params = {
                category: that.category,
                article: that.article,
            };
            getTutorialDetail(params).then((res) => {
                if (res.data) {
                    that.tutorialHtml = res.data.article.Message;
                    that.tutorialPre= res.data.prevArticle;
                    that.tutorialNext = res.data.nextArticle;

                    const articleList = res.data.articleList;
                    that.$set(that.tutorialList, that.tutorialList.length, { "TitleMenu": res.data.article.Title, "TitleMenuItem": [] })
                    
                    for(var i=0; i<articleList.length; i++) {
                        if(articleList[i].MarkerFlag == 1) {
                            that.$set(that.tutorialList, that.tutorialList.length, { "TitleMenu": articleList[i].Title, "TitleMenuItem": [] })
                        }
                        else {
                            that.$set(that.tutorialList[that.tutorialList.length-1].TitleMenuItem, that.tutorialList[that.tutorialList.length-1].TitleMenuItem.length, { "TitleMenuItem": articleList[i] })
                        }
                    }

                    for(var k=0; k<that.tutorialList.length; k++) {
                        that.defaultOpeneds.push(k.toString())
                    }   
                }
            });
        },
        handleOpen() {

        },
        handleClose() {

        },
        handleClick(item) {
            var that = this;
            that.category = item.CategorySlug;
            that.article = item.Slug;
            that.requestGetTutorialDetail();
            window.scrollTo(0, 0);
            window.globalStore.menuVisible = false;
        },
        // 获取教程详情
        requestGetTutorialDetail() {
            var that = this;
            var params = {
                category: that.category,
                article: that.article,
            };
            getTutorialDetail(params).then((res) => {
                if (res.data) {
                    that.tutorialHtml = res.data.article.Message;
                    that.tutorialPre= res.data.prevArticle;
                    that.tutorialNext = res.data.nextArticle;
                }
            });
        },
        // 上一页
        getTutorialPre(item) {
            var that = this;
            that.category = item.CategorySlug;
            that.article = item.Slug;
            that.activeSlug = item.Slug;
            window.scrollTo(0, 0);
            that.requestGetTutorialDetail();
        },
        // 下一页
        getTutorialPre(item) {
            var that = this;
            that.category = item.CategorySlug;
            that.article = item.Slug;
            that.activeSlug = item.Slug;
            window.scrollTo(0, 0);
            that.requestGetTutorialDetail();
        },
        // 菜单栏关闭
        menuVisibleClose() {
            window.globalStore.menuVisible = !window.globalStore.menuVisible;
        }
    },
    computed: {
        menuVisible() {
            return window.globalStore.menuVisible;
        }
    },
    watch: {
        menuVisible() {
        }
    }
}
</script>

<style lang="scss" scoped>
.td_content {
    width: 100%;
    min-height: calc(100vh - 60px);
    height: calc(100% - 60px);
    background: #F6F6F6;
    padding: 60px 0 0 0;

    display: flex;
    
    .td_side {
        width: 335px;
        height: calc(100vh - 60px);
        overflow: auto;
        scrollbar-width: none;
        .td_menu {
            width: 300px;
            height: auto;
        }

    }
    .td_side::-webkit-scrollbar {
        display: none;
    }

    .article {
        width: calc(100% - 359px);
        height: calc(100vh - 140px);
        overflow: auto;
        scrollbar-width: none;

        background: #FFFFFF;
        margin: 0 0 0 19px;
        padding: 50px 5% 30px 5%;

        .article-body {
            margin: 20px 0 20px 0;
        }

        .td_page {
            width: 100%;
            margin: 0 0 0 0;

            display: flex;
            justify-content: space-between;
            align-items: center;

            .page_pre {
                cursor: pointer;
            }

            .page_next {
                cursor: pointer;
            }

            
            .page_name1 {
                font-weight: normal;
                font-size: 16px;
                color: #A2A2A2;
                line-height: 22px;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }

            .page_arrow_name {
                display: flex;
                justify-content: center;
                align-items: center;

                margin: 13px 0 0 0;

                .page_arrow {
                    width: 24px;
                    height: 24px;
                    border-radius: 6px 6px 6px 6px;
                    border: 1px solid #000000;

                    
                    font-weight: normal;
                    font-size: 16px;
                    color: #000000;
                    line-height: 22px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;

                    display: flex;
                    justify-content: center;
                    align-items: center;

                }

                .page_name2 {
                    font-weight: normal;
                    font-size: 16px;
                    color: #000000;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
        }
    }
    .article::-webkit-scrollbar {
        display: none;
    }
}

@media screen and (max-width: 958px){
    .td_content {
        width: 100%;
        min-height: 100vh;
        height: 100%;
        background: #F6F6F6;
        padding: 60px 0 0 0;

        .td_side {
            position: fixed;
            width: 100%;
            height: calc(100% - 60px);
            background: rgba(0,0,0,0.3);
            overflow: auto;

            .td_menu {
                width: 75%;
                height: 100%;
            }
        }

        .active {
            display: none;
        }

        .article {
            width: calc(100%);
            height: auto;
            background: #FFFFFF;
            margin: 0 0 0 0;
            padding: 25px 0 15px 0;
            border-top: 1px solid rgba(0, 0, 0, .1);

            .article-body {
                margin: 25px 0 25px 0;
            }

            .td_page {
                width: calc(100% - 30px);
                margin: 0 0 0 0;
                padding: 0 15px 0 15px;

                display: flex;
                justify-content: space-between;
                align-items: center;

                .page_pre {
                    cursor: pointer;
                }

                .page_next {
                    cursor: pointer;
                }

                
                .page_name1 {
                    
                    font-weight: normal;
                    font-size: 14px;
                    color: #A2A2A2;
                    line-height: 15px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }

                .page_arrow_name {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    margin: 7px 0 0 0;

                    .page_arrow {
                        width: 18px;
                        height: 18px;
                        border-radius: 6px 6px 6px 6px;
                        border: 1px solid #000000;

                        
                        font-weight: normal;
                        font-size: 16px;
                        color: #000000;
                        line-height: 18px;
                        text-align: center;
                        font-style: normal;
                        text-transform: none;

                        display: flex;
                        justify-content: center;
                        align-items: center;

                    }

                    .page_name2 {
                        
                        font-weight: normal;
                        font-size: 14px;
                        color: #000000;
                        line-height: 15px;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
            }
        }
    }
}

/deep/.el-submenu__title {
    background: #F7FAFF !important;
    color: #0042C1 !important;
    font-weight: bold !important;
    font-size: 18px !important;
    border: 1px solid #E4EEFF !important;
}
/deep/.el-submenu {
    background: #F7FAFF !important;
    color: #0042C1 !important;
}
/deep/.el-submenu__title:hover {
    background: #F7FAFF !important;
    color: #0042C1 !important;
}
/deep/.el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
}
/deep/.el-menu-item:hover {
    background: #F7FAFF !important;
    color: #0042C1 !important;
}
/deep/.el-menu-item.is-active {
    background: #F7FAFF !important;
    color: #0042C1 !important;
}
</style>